import { defaultLanguage, type Language } from "./Language";
import type { PerfumeIngredient } from "./Perfume";

export function capitalizeIngredientName(name: string) {
  return name
    .split(" ")
    .filter((w) => !!w)
    .map((w) => {
      const firstLetter = w[0].toLocaleUpperCase();
      const rest = w.slice(1).toLocaleLowerCase();
      return firstLetter + rest;
    })
    .join(" ");
}

export function ingredientDisplayName(ingredient: PerfumeIngredient, language: Language): string {
  return ingredient.displayName === null
    ? capitalizeIngredientName(ingredient.name)
    : ingredient.displayName[language] || ingredient.displayName[defaultLanguage];
}
